<template>
  <div id="main-listado-contrato-garantias">
    <!-- Lista Escritorio -->
    <template>
      <desktop :listadoGarantias="listadoGarantias" />
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';

export default {
  name: 'MainListadoContratoGarantias',
  components: {
    Desktop,
  },
  props: {
    listadoGarantias: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
